export default function Footer() {
  return (
    <footer
      data-testid="site-footer"
      className="border-t border-white/8 px-4 sm:px-8 lg:px-16 py-14"
    >
      <div className="grid grid-cols-1 md:grid-cols-12 gap-10">
        <div className="md:col-span-5">
          <p className="font-display font-black text-2xl tracking-[0.2em] uppercase mb-4">
            Aetheria<span className="text-magma">.</span>
          </p>
          <p className="text-sm text-slate-500 leading-relaxed max-w-sm">
            All units are synthetic adult companions. Strictly 18+. On-device
            intelligence, zero cloud retention, discreet worldwide shipping in
            unmarked crates.
          </p>
        </div>
        <div className="md:col-span-3">
          <p className="font-mono-tech text-[10px] uppercase tracking-[0.3em] text-slate-500 mb-4">
            Collection
          </p>
          <ul className="space-y-2 text-sm text-slate-400">
            <li><a href="/#catalog" className="hover:text-cyber transition-colors">Male Units</a></li>
            <li><a href="/#catalog" className="hover:text-cyber transition-colors">Female Units</a></li>
            <li><a href="/#catalog" className="hover:text-cyber transition-colors">Fluid Units</a></li>
          </ul>
        </div>
        <div className="md:col-span-4">
          <p className="font-mono-tech text-[10px] uppercase tracking-[0.3em] text-slate-500 mb-4">
            Assurance
          </p>
          <ul className="space-y-2 text-sm text-slate-400">
            <li>5-year endoskeleton warranty</li>
            <li>Lifetime neural-core updates</li>
            <li>Neutral billing descriptor</li>
            <li>White-glove delivery, unmarked</li>
          </ul>
        </div>
      </div>
      <div className="mt-14 pt-6 border-t border-white/8 flex flex-col sm:flex-row justify-between gap-3">
        <p className="font-mono-tech text-[10px] uppercase tracking-[0.25em] text-slate-600">
          © 2026 Aetheria Companion Systems
        </p>
        <p className="font-mono-tech text-[10px] uppercase tracking-[0.25em] text-slate-600">
          Adults only // Synthetic by design
        </p>
      </div>
    </footer>
  );
}
